import { render } from "./BulkEditor.vue?vue&type=template&id=7b5581af&ts=true"
import script from "./BulkEditor.vue?vue&type=script&lang=ts"
export * from "./BulkEditor.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__